import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { emp } from './gridData';
import Services from './Services';
import { useTheme } from '@emotion/react';
import { CustomizedDataGrid } from '../../components';
import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box, Backdrop, CircularProgress, useMediaQuery } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ProjectEmployees = ({projectId, open, handleClose}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [open1, setOpen1] = React.useState(false);

    const close1 = () => setOpen1(false);

    const [loading, setLoading] = React.useState(false);
    const [employees, setEmployees] = React.useState([]);

    const getEmp = async(id) => {
        setLoading(true);
        await jaxa.get('/get-supervisor-projects-employees', { params: { projectId: id } }).then((res) => setEmployees(res.data)).catch((e) => {
            Swal.fire({ title: 'Failed to load employees' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
    };

    React.useEffect(() => {
        getEmp(projectId)
    }, [projectId]);

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress />
        </Backdrop>
    ), []);

    return (

        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} TransitionComponent={Transition}
        PaperProps={{
            sx: {
              height: '650px', 
            }
        }}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close">
                    <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Employees</Typography>
                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <CustomizedDataGrid columns={emp} rows={employees} onClick={e => setOpen1(e)}/>
            </Box>
            {loading ? loader : null}
            {open1 ? <Services projectId={projectId} empId={open1} open={Boolean(open1)} handleClose={close1} goToProjects={handleClose}/> : null}
        </Dialog>

    );

};

export default React.memo(ProjectEmployees);